import ApplyRoutes from "@/routes/ApplyRoutes"
import DocumentRoutes from "@/routes/DocumentRoutes"
import HelpRoutes from "@/routes/HelpRoutes"
import ProviderRoutes from "@/routes/ProviderRoutes"
import StartRoutes from "@/routes/StartRoutes"
import FinishRoutes from "@/routes/FinishRoutes"
import ErrorRoutes from "@/routes/ErrorRoutes"
import InternalRoutes from "@/routes/InternalRoutes"
import TestRoutes from "@/routes/TestRoutes"

export default [
    ...ProviderRoutes,
    ...ApplyRoutes,
    ...DocumentRoutes,
    ...ErrorRoutes,
    ...HelpRoutes,
    ...InternalRoutes,
    ...StartRoutes,
    ...TestRoutes,
    ...FinishRoutes,

    {
        path: "/",
        name: "home",
        component: () => import("@/views/HomeView"),
        meta: {
            stepper: false,
            title: "Home Page - ClearChoice",
        },
    },
    {
        path: "/idle",
        name: "idle",
        component: () => import("@/views/IdleView"),
        meta: {
            public: true,
            stepper: false
        },
    },

    {
        path: "*",
        redirect: "/",
    },
]
